export const GROUP_NAME_MAX_LENGTH = 255
export const GROUP_NAME_MAX_LENGTH_MESSAGE = `Group name must not exceed ${GROUP_NAME_MAX_LENGTH} characters`
